export function isProduct(item) {
    return item.section === 'Products';
}
export function isSearchSuggestion(item) {
    return item.section === 'Search Suggestions';
}
export function isInGroupSuggestion(item) {
    return item.groupName !== undefined;
}
export function isCustomSection(config) {
    return config.data !== undefined;
}
